import {
	CREATE_REVIEW_REQUEST,
	CREATE_REVIEW_REQUEST_FAILED,
	CREATE_REVIEW_REQUEST_RESET,
	CREATE_REVIEW_REQUEST_SUCCESS,
	GET_ALL_REVIEWS_LIST_REQUEST,
	GET_ALL_REVIEWS_LIST_REQUEST_FAILED,
	GET_ALL_REVIEWS_LIST_REQUEST_RESET,
	GET_ALL_REVIEWS_LIST_REQUEST_SUCCESS,
	GET_REVIEW_BASED_ON_ID,
	GET_REVIEW_BASED_ON_ID_FAILED,
	GET_REVIEW_BASED_ON_ID_RESET,
	GET_REVIEW_BASED_ON_ID_SUCCESS,
	GET_REVIEW_LIST_REQUEST,
	GET_REVIEW_LIST_REQUEST_FAILED,
	GET_REVIEW_LIST_REQUEST_RESET,
	GET_REVIEW_LIST_REQUEST_SUCCESS,
	GET_REVIEW_REQUEST,
	GET_REVIEW_REQUEST_FAILED,
	GET_REVIEW_REQUEST_RESET,
	GET_REVIEW_REQUEST_SUCCESS,
	IS_CASE_ADMIN,
	IS_UPDATE_TRIGGER,
	RESET_REVIEW,
	RESET_REVIEW_FORM,
	SET_REVIEW,
	SET_REVIEW_ASSIGNEE,
	SET_REVIEW_ASSIGNEE_MAP,
	SET_REVIEW_CURRENT_ASSIGNEE,
	SET_REVIEW_FORM_OPEN,
	SET_REVIEW_JOBID,
	SET_REVIEW_RESTRICT_IDS,
	UPDATE_REVIEW_METADATA,
	UPDATE_REVIEW_STATUS,
	UPDATE_REVIEW_STATUS_FAILED,
	UPDATE_REVIEW_STATUS_RESET,
	UPDATE_REVIEW_STATUS_SUCCESS,
} from "../types"

export const setReview = (data) => ({
	type: SET_REVIEW,
	payload: data,
})

export const reSetReview = (data) => ({
	type: RESET_REVIEW,
})

export const setJobReviewId = (data) => ({
	type: SET_REVIEW_JOBID,
	payload: data,
})

export const setReviewAsignee = (data) => ({
	type: SET_REVIEW_ASSIGNEE,
	payload: data,
})

export const setReviewCurrentAsignee = (data) => ({
	type: SET_REVIEW_CURRENT_ASSIGNEE,
	payload: data,
})

export const setReviewAssigneeMap = (data) => ({
	type: SET_REVIEW_ASSIGNEE_MAP,
	payload: data,
})

export const resetReviewForm = (data) => ({
	type: RESET_REVIEW_FORM,
	payload: data,
})

export const setIsCaseAdmin = (data) => ({
	type: IS_CASE_ADMIN,
	payload: data,
})

//Create review
export const createReviewRequest = (data) => ({
	type: CREATE_REVIEW_REQUEST,
	payload: data,
})

export const createReviewRequestSuccess = (data) => ({
	type: CREATE_REVIEW_REQUEST_SUCCESS,
	payload: data,
})

export const createReviewRequestFailed = (data) => ({
	type: CREATE_REVIEW_REQUEST_FAILED,
	payload: data,
})

export const createReviewRequestReset = () => ({
	type: CREATE_REVIEW_REQUEST_RESET,
})

//review list
export const getReviewListRequest = (data) => ({
	type: GET_REVIEW_LIST_REQUEST,
	payload: data,
})

export const getReviewListSuccess = (data) => ({
	type: GET_REVIEW_LIST_REQUEST_SUCCESS,
	payload: data,
})

export const getReviewListFailed = (data) => ({
	type: GET_REVIEW_LIST_REQUEST_FAILED,
	payload: data,
})

export const getReviewListReset = () => ({
	type: GET_REVIEW_LIST_REQUEST_RESET,
})

//get all reviews
export const getAllReviewListRequest = (data) => ({
	type: GET_ALL_REVIEWS_LIST_REQUEST,
	payload: data,
})

export const getAllReviewListSuccess = (data) => ({
	type: GET_ALL_REVIEWS_LIST_REQUEST_SUCCESS,
	payload: data,
})

export const getAllReviewListFailed = (data) => ({
	type: GET_ALL_REVIEWS_LIST_REQUEST_FAILED,
	payload: data,
})

export const getAllReviewListReset = () => ({
	type: GET_ALL_REVIEWS_LIST_REQUEST_RESET,
})

//get single review
export const getReviewRequest = (data) => ({
	type: GET_REVIEW_REQUEST,
	payload: data,
})

export const getReviewRequestSuccess = (data) => ({
	type: GET_REVIEW_REQUEST_SUCCESS,
	payload: data,
})

export const getReviewRequestFailed = (data) => ({
	type: GET_REVIEW_REQUEST_FAILED,
	payload: data,
})

export const getReviewRequestReset = () => ({
	type: GET_REVIEW_REQUEST_RESET,
})

export const setReviewRestrictIds = (data) => ({
	type: SET_REVIEW_RESTRICT_IDS,
	payload: data,
})

export const setReviewFormOpen = (data) => ({
	type: SET_REVIEW_FORM_OPEN,
	payload: data,
})

export const updateReviewStatus = (data) => ({
	type: UPDATE_REVIEW_STATUS,
	payload: data,
})

export const updateReviewStatusSuccess = (data) => ({
	type: UPDATE_REVIEW_STATUS_SUCCESS,
	payload: data,
})

export const updateReviewStatusFailed = (data) => ({
	type: UPDATE_REVIEW_STATUS_FAILED,
	payload: data,
})

export const updateReviewStatusReset = () => ({
	type: UPDATE_REVIEW_STATUS_RESET,
})

export const updateReviewMetada = (data) => ({
	type: UPDATE_REVIEW_METADATA,
	payload: data,
})

export const isReviewUpdateTrigger = (data) => ({
	type: IS_UPDATE_TRIGGER,
	payload: data,
})

export const getReviewBasedOnFileIdRequest = (data) => ({
	type: GET_REVIEW_BASED_ON_ID,
	payload: data,
})

export const getReviewBasedOnFileIdSuccess = (data) => ({
	type: GET_REVIEW_BASED_ON_ID_SUCCESS,
	payload: data,
})

export const getReviewBasedOnFileIdFailed = (data) => ({
	type: GET_REVIEW_BASED_ON_ID_FAILED,
	payload: data,
})

export const getReviewBasedOnFileIdReset = () => ({
	type: GET_REVIEW_BASED_ON_ID_RESET,
})
